import React, { createContext, useCallback, useState } from 'react';

import ToastNotificationsContainer from './toastNotificationsContainer.component';

const TOAST_TIMEOUT = 3000;

export type ToastData = {
    id: number;
    props: ToastProps;
};

export enum ToastNotificationType { SUCCESS, ERROR }

type ToastProps = {
    type: ToastNotificationType;
    message: string;
}

export type ToastContextType = {
    showToast: (props: ToastProps) => void;
};

export const ToastNotificationContext = createContext<ToastContextType | undefined>(undefined);
export const ToastNotificationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [toasts, setToasts] = useState<ToastData[]>([]);

    const showToast = useCallback((props: ToastProps) => {
        const id = Date.now();
        setToasts(prev => [...prev, { id, props }]);
        setTimeout(() => {
            setToasts(prev => prev.filter(toast => toast.id !== id));
        }, TOAST_TIMEOUT);
    }, []);

    return (
        <ToastNotificationContext.Provider value={{ showToast }}>
            {children}
            <ToastNotificationsContainer toasts={toasts} setToasts={setToasts} />
        </ToastNotificationContext.Provider>
    );
};
